import { Component, Input } from "@angular/core";

@Component({
    selector: "designer",
    templateUrl: "./designer.component.html",
    styleUrls: ["./designer.component.scss"],
    standalone: false,
})
export class DesignerComponent {
    @Input() isViewMode = false;
    @Input() isGlb = false;

    constructor() {}
}
